"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ConfigProvider = require("../../provider/ConfigProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = require('./style.module.scss');

var FooterNavigation = function FooterNavigation(_ref) {
  var _cn2;

  var highlightRightButton = _ref.highlightRightButton,
      rightButtonDisabled = _ref.rightButtonDisabled,
      hideLeftButton = _ref.hideLeftButton,
      buttonRightText = _ref.buttonRightText,
      buttonLeftText = _ref.buttonLeftText,
      hideButtonChevrons = _ref.hideButtonChevrons,
      onLeftButtonClick = _ref.onLeftButtonClick,
      onRightButtonClick = _ref.onRightButtonClick,
      _ref$configurationCon = _ref.configurationContext,
      configurationContext = _ref$configurationCon === void 0 ? _ConfigProvider.ConfigurationContext : _ref$configurationCon;

  var _useContext = (0, _react.useContext)(configurationContext || _ConfigProvider.ConfigurationContext),
      config = _useContext.config;

  var discriminator = (config === null || config === void 0 ? void 0 : config.discriminator) || 'jmm';

  var scrollToTop = function scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    return;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames.default)(styles.footerPlacer, styles[discriminator]),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles.footerNavi,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        container: true,
        alignItems: "center",
        alignContent: "center",
        className: styles.footerShadowTop,
        justify: "space-between",
        item: true,
        xs: 12,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 4,
          sm: 3,
          className: styles.footerPadding,
          children: !hideLeftButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
            fullHeight: true,
            fullWidth: true,
            className: styles.left,
            onClick: function onClick() {
              scrollToTop();
              onLeftButtonClick();
            },
            children: [!hideButtonChevrons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronLeft.default, {}), buttonLeftText]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 4,
          sm: 3,
          className: (0, _classnames.default)(styles.footerPadding, (0, _defineProperty2.default)({}, styles.highlight, highlightRightButton)),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
            fullHeight: true,
            fullWidth: true,
            disabled: !!rightButtonDisabled,
            className: (0, _classnames.default)(styles.right, (_cn2 = {}, (0, _defineProperty2.default)(_cn2, styles.nonClickable, rightButtonDisabled), (0, _defineProperty2.default)(_cn2, styles.highlight, highlightRightButton), _cn2)),
            onClick: function onClick() {
              scrollToTop();
              onRightButtonClick();
            },
            children: [buttonRightText, !hideButtonChevrons && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronRight.default, {})]
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})]
    })
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(FooterNavigation);

exports.default = _default;